import cx from "classnames"
import { camelize } from "../../utils"
import type { IconColorsType } from "../"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "linkedin"
const LinkedinIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    },
  )
  return (
    <span className={computedClassName}>
      {
        <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
          <title>{iconSource}</title>
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M7.863 9.199V20H4.21V9.199h3.653Zm.232-3.335c.007.53-.179.973-.559 1.33-.38.357-.88.534-1.5.534h-.022c-.605 0-1.092-.178-1.46-.535A1.773 1.773 0 0 1 4 5.863c0-.537.19-.982.57-1.334C4.95 4.176 5.446 4 6.059 4c.613 0 1.103.176 1.472.529.369.352.557.797.564 1.335Zm5.423 4.87c.14-.218.285-.41.432-.576a4.75 4.75 0 0 1 .625-.567 2.91 2.91 0 0 1 .963-.474 4.45 4.45 0 0 1 1.267-.169c1.262 0 2.277.413 3.044 1.237.767.825 1.151 2.033 1.151 3.624V20h-3.641v-5.777c0-.763-.15-1.36-.449-1.792-.299-.432-.765-.649-1.4-.649-.464 0-.854.125-1.167.376-.314.25-.548.561-.703.932-.081.218-.122.512-.122.883V20H9.877c.015-2.9.022-5.25.022-7.052 0-1.802-.004-2.877-.011-3.226L9.877 9.2h3.641v1.534Z"
          />
        </svg>
      }
    </span>
  )
}
export default LinkedinIcon
